<template>
  <vuetify-aggregator-card
    ref="aggregator"
    :color="color"
    :toolbar-title="toolbarTitle"
    :list-title="listTitle"
    :navigation-menu="navigationMenu"
    :add-button-hover-text="addButtonHoverText"
    :dialog-max-width="dialogMaxWidth"
    :dialog-toolbar-title="dialogToolbarTitle"
  >
    <v-list two-line slot="card-text" v-if="items.length > 0">
      <transition-group name="list" tag="span">
        <template v-for="(item, index) in items">
          <v-list-tile :key="(index + 2 * 100)">
            <v-list-tile-avatar v-if="item.avatar">
              <img :src="item.avatar">
            </v-list-tile-avatar>
            <v-list-tile-action v-else>
              <v-icon :color="color">{{ leftIcon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="deleteButton">
              <v-tooltip bottom>
                <v-btn slot="activator" icon flat :color="color" @click="askForConfirmation(index)">
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>{{ deleteIconHoverText }}</span>
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 !== items.length" :inset="false" :key="(index + 1 * 100)"></v-divider>
        </template>
      </transition-group>
    </v-list>

    <v-layout slot="dialog-card-text" row align-center justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-form ref="form" v-model="valid">
          <vuetify-select
            v-if="list && usersList.length > 0"
            ref="select"
            v-model="select.value"
            :item="select"
            @on-add-item="onAddItem"
            @on-change="onChange"
            @on-keyup="onKeyup"
          ></vuetify-select>
          <v-text-field
            v-else
            :label="textFieldLabel"
            single-line
            required
            :rules="textFieldRules || []"
            v-model="name"
          ></v-text-field>
        </v-form>
      </v-flex>
    </v-layout>

    <div slot="dialog-card-actions">
      <v-btn
        :color="color"
        flat
        @click.native="$refs.aggregator.dialog = false"
      >
        {{ cancelButton }}
      </v-btn>
      <v-btn
        v-show="valid && showConfirmButton"
        :color="color"
        flat
        @click.native="addUser()"
      >
        {{ confirmButton }}
      </v-btn>

    </div>

    <vuetify-dialog-confirm
      slot="extras"
      :headline="dialogConfirmHeadline"
      :text="dialogConfirmText"
      :cancel="cancelButton"
      :confirm="confirmButton"
      @on-cancel-dialog="onDiscardDeletion"
      @on-confirm-dialog="onConfirmDeletion"
      v-model="showConfirmDialog"
    ></vuetify-dialog-confirm>

  </vuetify-aggregator-card>
</template>

<script>
  'use strict'

  import VuetifyAggregatorCard from '@/layouts/vuetify-aggregator-card'
  import VuetifyDialogConfirm from '@/components/vuetify-dialog-confirm'
  import VuetifySelect from '@/components/vuetify-form-creator/fields/vuetify-select'

  export default {

    name: 'VuetifyUserAggregator',

    components:
    {
      VuetifyAggregatorCard,
      VuetifyDialogConfirm,
      VuetifySelect
    },

    props: {
      users: {
        type: Array,
        default: null,
        required: true
      },
      color: {
        type: String,
        default: 'primary',
        required: false
      },
      toolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      listTitle: {
        type: String,
        default: null,
        required: true
      },
      addButtonHoverText: {
        type: String,
        default: null,
        required: true
      },
      navigationMenu: {
        type: Boolean,
        default: true,
        required: false
      },
      deleteButton: {
        type: Boolean,
        default: true,
        required: false
      },
      dialogMaxWidth: {
        type: Number,
        default: 450,
        required: false
      },
      dialogToolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      textFieldLabel: {
        type: String,
        default: 'Phone',
        required: false
      },
      textFieldRules: {
        type: Array,
        default: null,
        required: false
      },
      selectLabel: {
        type: String,
        default: 'Type',
        required: false
      },
      usersList: {
        type: Array,
        default: null,
        required: false
      },
      dialogConfirmHeadline: {
        type: String,
        default: 'Delete area',
        required: false
      },
      dialogConfirmText: {
        type: String,
        default: 'Estás a punto de eliminar un área de trabajo',
        required: false
      },
      cancelButton: {
        type: String,
        default: 'Cancel',
        required: false
      },
      confirmButton: {
        type: String,
        default: 'Confirm',
        required: false
      },
      deleteIconHoverText: {
        type: String,
        default: 'Delete',
        required: false
      },
      leftIcon: {
        type: String,
        default: 'supervisor_account',
        required: false
      },
      addOnEnter: {
        type: Boolean,
        default: false,
        required: false
      },
      hiddenMenuWhenNoOptions: {
        type: Boolean,
        default: false,
        required: false
      },
      returnObject: {
        type: Boolean,
        default: false,
        required: false
      },
      noDataText: {
        type: String,
        default: false,
        required: false
      },
      value: {
        type: Array,
        default: null
      }
    },

    data: () => ({
      items: [],
      dialog: false,
      valid: false,
      showConfirmDialog: false,
      currentIndex: 0,
      showConfirmButton: true,
      select: {
        items: [],
        item_text: 'name',
        item_value: 'id',
        label: '',
        no_data_text: null,
        value: [],
        dark: false,
        color: 'primary',
        columns: 'xs12 sm6 md6 lg6',
        disabled: false,
        autocomplete: true
      },
      list: null,
      name: null
    }),

    created () {
      this.select.items = this.usersList
      this.select.label = this.textFieldLabel
      this.select.no_data_text = this.noDataText
      this.select.return_object = this.returnObject
    },

    watch: {
      usersList: {
        handler: function (newVal, oldVal) {
          this.list = newVal
          this.select.items = this.usersList
        },
        deep: true
      },

      users: {
        handler: function (newVal, oldVal) {
          this.items = newVal
        },
        deep: true
      },

      items: {
        handler: function (newVal, oldVal) {
          this.$emit('update:value', newVal)
        },
        deep: true
      }
    },

    methods: {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      askForConfirmation (index) {
        this.currentIndex = index
        this.showConfirmDialog = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onAddItem (newVal, oldVal, item, isValid) {
        if (this.addOnEnter && !this.showConfirmButton) {
          this.$refs.aggregator.dialog = false
          this.$refs.form.reset()
          this.$emit('on-add-new-user', newVal, oldVal, item, isValid)
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChange (newVal, oldVal, item, isValid) {
        if (isValid && newVal !== oldVal) {
          this.select.value = newVal
        }
        this.showConfirmButton = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onKeyup () {
        if (this.addOnEnter) {
          this.showConfirmButton = this.$refs.select.filteredItems
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onDiscardDeletion (ref) {
        this.showConfirmDialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onConfirmDeletion () {
        this.showConfirmDialog = false
        this.deleteUser()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteUser () {
        this.$emit('on-delete-user', this.items[this.currentIndex], this.currentIndex)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addUser () {
        this.$refs.aggregator.dialog = false
        let item = {
          id: this.select.value.id ? this.select.value.id : 0,
          avatar: '',
          gender: '',
          name: this.select.value.name ? this.select.value.name : this.name
        }

        this.$refs.form.reset()
        this.$emit('on-add-user', item)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/vuetify-user-aggregator.vue